import React from "react";
import "./DeleteModal.css";

const DeleteModal = ({ show, onClose, onDelete }) => {
  if (!show) return null; // Don't render the modal if show is false

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        <h5>Are you sure you want to delete this post?</h5>
        <div className="delete-modal-actions">
          <button className="delete-modal-btn delete-confirm" onClick={onDelete}>
            <i className="bi bi-check-circle"></i> Yes
          </button>
          <button className="delete-modal-btn delete-cancel" onClick={onClose}>
            <i className="bi bi-x-circle"></i> No
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
